import { observable, action, makeObservable, set } from 'mobx';

import { OrganizationType } from '../../shared/support/modelTypes';

export interface OrganizationFormStoreType {
	model: OrganizationType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude?: Array<any>;
	selectedItems: Array<any>;
	isFirstLoad: boolean;
	name: string;
	setValue(model: any, key: string, value: any): void;
}

class OrganizationFormStore implements OrganizationFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			selectedItems: observable,
			isFirstLoad: observable,
			name: observable,
			setValue: action
		});
	}

	model = {
		typeId: null,
		bankAccountId: null,
		directorId: null,
		chiefAccountantId: null,
		itn: null,
		iec: null,
		okato: null,
		oktmo: null,
		psrn: null,
		name: { ru: '' },
		displayName: null,
		priority: null,
		deleted: false
	};
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	pluralName = 'organizations';
	filterInclude = ['type', 'director', 'chiefAccountant', 'bankAccount'];
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	isFirstLoad = true;
	name = 'OrmOrganization';
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const organizationFormStore = new OrganizationFormStore();

export default OrganizationFormStore;
